// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { getCustomerEmail, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Header } from '../../../organisms/header';

import { MerchantInfo } from '../../../organisms/merchant-info';
import { MobileDisplayValues } from '../../../organisms/mobile-display-values';
import { Separator } from '../../../atoms';

import { PaymentInstructions } from './payment-instructions';
import { Ticket } from './ticket';
import { VoucherButton } from './voucher-button';
import {
  NotificationBox,
  QuestionIcon,
} from '@tectonics/look-and-feel/volcanes/atoms/notification-box-chilean';
import questionImageSrc from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/customer-form/chilean/question-mark-icon.svg';

export function BankTransferPage(): Node {
  const incomingPayment = useIncomingPayment();

  return (
    <Root data-test-id="bank-transfer-page-pending-payment">
      <Header />
      <MobileDisplayValues />
      <Body>
        <Title>Tu factura ha sido generada!</Title>
        <PaymentWarningWrapperContent>
          Una copia de la factura fue enviada a <strong> {getCustomerEmail(incomingPayment)}</strong>. Ya puedes pagar tu compra con los siguientes datos:
        </PaymentWarningWrapperContent>
        <Separator direction="vertical" size={4} />
        <Ticket />
        <Separator direction="vertical" size={4} />
        <VoucherButton />
        <NotificationBox>
          <div>
            <QuestionIcon src={questionImageSrc} alt="questionIcon" />
          </div>
          <div>
            Averigue que el RUT informado en la compra sea el mismo que se utilizará para realizar el pago, para evitar problemas con el procesamiento y la posible cancelación de la transacción.
          </div>
        </NotificationBox>
        <Separator direction="vertical" size={4} />
        <PaymentInstructions />
        <Separator direction="vertical" size={4} />
        <MerchantInfo />
      </Body>
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 16px;
`;

const Title = styled.h1`
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
`;

const PaymentWarningWrapperContent = styled.p`
  padding-top: 7px;
  font-size: 14px;
  font-family: ${props => props.theme.fontFamily.sansSerif};
`;
